/**
 * LP Subscribe Component
 *
 * Handles newsletter subscription form interactions
 */
class LpSubscribe extends HTMLElement {
  constructor() {
    super();
    
    this.form = this.querySelector('.lp-subscribe__form');
    this.input = this.querySelector('.lp-subscribe__input');
    this.button = this.querySelector('.lp-subscribe__button');
    this.errorMessage = this.querySelector('.lp-subscribe__message--error');
    this.successMessage = this.querySelector('.lp-subscribe__message--success');
    
    this.init();
  }

  init() {
    if (!this.form) return;
    
    // Handle form submission animation
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    
    // Auto-focus error/success messages for accessibility
    if (this.errorMessage) {
      this.errorMessage.focus();
    }
    
    if (this.successMessage) {
      this.successMessage.focus();
    }
  }

  handleSubmit(event) {
    // Add loading state to button
    if (this.button) {
      const originalText = this.button.textContent;
      this.button.textContent = 'Subscribing...';
      this.button.disabled = true;
      
      // Reset button after form processes (in case of client-side validation failure)
      setTimeout(() => {
        if (this.button.disabled) {
          this.button.textContent = originalText;
          this.button.disabled = false;
        }
      }, 3000);
    }
  }
}

if (!customElements.get('lp-subscribe')) {
  customElements.define('lp-subscribe', LpSubscribe);
}
